import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';

import { Button, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsChooseNewButton = (props: Props) => {
  const { count, palette, disabled, onPress } = props;

  // ─── Derived ─────────────────────────────────────────────────────────

  const message = count === 1 ? messages.chooseNewIngredient : messages.chooseNewIngredients;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Button
      size="large-wide"
      style={styles.button}
      width="100%"
      palette={palette}
      disabled={disabled}
      onPress={onPress}
      accessibilityRole="button"
    >
      <FormattedMessage {...message} />
    </Button>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  chooseNewIngredient: {
    defaultMessage: 'Choose a new ingredient',
    description: 'Add To Bag | Unavailable ingredients | Choose new ingredient CTA (single)',
  },
  chooseNewIngredients: {
    defaultMessage: 'Choose new ingredients',
    description: 'Add To Bag | Unavailable ingredients | Choose new ingredients CTA (multiple)',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  count: number;
  palette: 'primary' | 'secondary';
  disabled: boolean;
  onPress: () => void;
};
